export const IOS_APP_STORE_ID = '6761429006';

export const IOS_APP_STORE_URL = `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`;

export const IOS_APP_STORE_ITMS_URL = `itms-apps://itunes.apple.com/app/id${IOS_APP_STORE_ID}`;

export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.lezzetyolda.customer';

export const MOBILE_APP_DOWNLOAD_PATH = '/indir';

export const PRODUCTION_SITE_ORIGIN = 'https://lezzetyolda.com';

const IOS_USER_AGENT_PATTERN = /iPhone|iPad|iPod/i;

export function isIosDevice(userAgent = navigator.userAgent): boolean {
  return IOS_USER_AGENT_PATTERN.test(userAgent);
}

export function resolveMobileAppDownloadUrl(): string {
  const origin =
    typeof window !== 'undefined' ? window.location.origin : PRODUCTION_SITE_ORIGIN;
  return `${origin}${MOBILE_APP_DOWNLOAD_PATH}`;
}

export function resolveMobileAppStoreUrl(userAgent = navigator.userAgent): string | null {
  if (isIosDevice(userAgent)) {
    return IOS_APP_STORE_ITMS_URL;
  }
  if (/Android/i.test(userAgent)) {
    return ANDROID_PLAY_STORE_URL;
  }
  return null;
}
